export enum IssueTimelineEventTypeEnum {
  IssueCreated = 'issue-created',
  IssueAssigned = 'issue-assigned',
  IssueClosed = 'issue-closed',
  IssueDiscarded = 'issue-discarded',
  IssueApproved = 'issue-approved',
  IssueDeclined = 'issue-declined',
  IssueDeclinedBeforePublishing = 'issue-declined-before-publishing',
  IssueEdited = 'issue-edited',
  PendingAcceptanceDeclined = 'issue-pending-acceptance-declined',
  MovedToOpen = 'issue-moved-to-open',
  ApprovedForPublishing = 'issue-approved-for-publishing',
  IssuePublished = 'issue-published',
  MovedToDraft = 'issue-moved-to-draft',
  ActionEdited = 'action-edited',
  ActionAdded = 'action-added',
  ActionDeleted = 'action-deleted',
  IssueToBeApproved = 'issue-to-be-approved',
  CommentAdded = 'comment-added',
  ActionCreated = 'action-created',
  ActionInitiated = 'action-initiated',
  ActionStarted = 'action-started',
  ActionCompleted = 'action-completed',
  ActionToBeApproved = 'action-to-be-approved',
  ActionApproved = 'action-approved',
  ActionRejected = 'action-rejected',
  ActionDiscarded = 'action-discarded',
  ActionOpened = 'action-opened',
  SLADeactivated = 'sla-deactivated',
  SLAActivated = 'sla-activated',
  AttachmentDeleted = 'attachment-deleted',
  RelationshipAdded = 'relationship-added',
  RelationshipDeleted = 'relationship-deleted',
}
